var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-cell-group',{attrs:{"title":_vm.title}},[_vm._t("prepend"),(_vm.loading)?_c('van-loading',{attrs:{"size":"24px"}},[_vm._v("加载中...")]):(_vm.form)?_vm._l((_vm.cells),function(c){return _c('van-cell',{key:c.id,attrs:{"title":c.label.text}},[_vm._v(_vm._s(_vm.getDisplayText(c)))])}):_vm._e(),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }